export default __webpack_public_path__ + "static/media/wazdan-mono.24b98257.svg";